// frontend/src/core/auth/useAdminPermission.ts
//
// Hook + helper for checking the calling super-admin's effective permissions.
// `owner` is normalised on the server side (loadAdminPermissions expands it to
// the full registry) so a simple .includes() check is enough.

import { useAuth } from './AuthProvider';

export function useAdminPermission(key: string): boolean {
  const { identity } = useAuth();
  if (!identity || identity.type !== 'super_admin') return false;
  if (identity.roles?.includes('owner')) return true;
  return identity.permissions?.includes(key) ?? false;
}

export function useAdminRole(roleKey: string): boolean {
  const { identity } = useAuth();
  if (!identity || identity.type !== 'super_admin') return false;
  return identity.roles?.includes(roleKey) ?? false;
}
